import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { ImageType } from '@/types/image-types'
import { Treatment } from '@/types/treatment'

export interface CaneDiagnosis {
  demand_name: string
  culture: Culture
  treatment: Treatment
  status: {
    name: string
    label: string
    description: string
    status_key:
      | 'registered'
      | 'processing'
      | 'completed'
      | 'rejected'
      | 'reported'
      | 'cancelled'
  }
  id: string
  user: { id: number; name: string }
  mosaic: {
    id: string
    date: string
    datum: string
    filename: string
    gsd: number
    image_type: ImageType
    image_count: number | null
  }
  registration_date: string
  concluded_at: string
  company: {
    id: number
    name: string
  }
  project: {
    id: number
    name: string
    region_id: number | null
  }
  perimeter: {
    area: number
  }
  files: {
    pulverization: string | null
    pulverization_pdf: string | null
    pulverization_spreadsheet: string | null
    pulverization_splitted: string | null
    pulverization_splitted_pdf: string | null
  }
}

export async function getDiagnosisById(
  treatment: Treatment,
  culture: Culture,
  id: string,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<CaneDiagnosis>(
    apiRoutes.getDiagnosisById(treatment, culture, id),
    options,
  )
  return data
}
